import {useCallback} from 'react';
import {useSearchParams} from 'react-router-dom';

import {toggleTagInSearchParams} from 'shared/lib/filterHelper';

const useToggleTagFilter = (): (_tag: string) => void => {
    const [searchParams, setSearchParams] = useSearchParams();

    return useCallback((tag: string) => {
        setSearchParams(toggleTagInSearchParams(searchParams, tag));
    }, [searchParams, setSearchParams]);
};

export default useToggleTagFilter;
